import Const from 'constants';
import Action from 'actions';

let DominatorStacking = {
    useDominatorStacking(use) {
        return {
            type: Const.DOMINATOR_STACKING_SET_IS_USED,
            use,
        };
    },

    addItemToPlayerDominatorStacking(item) {
        return (dispatch) => {
            dispatch({
                type: Const.DOMINATOR_STACKING_ADD_ITEM,
                item,
            });
        };
    },

    removeItemOfDominatorStacking(itemId) {
        return (dispatch) => {
            dispatch({
                type: Const.DOMINATOR_STACKING_REMOVE_ITEM,
                itemId,
            });
        };
    },
};

export default Object.assign(Action, DominatorStacking);
